// src/components/onboarding/Step1PersonalInfo.jsx
import React from 'react';
import { Typography, TextField, Box } from '@mui/material';

function Step1PersonalInfo({ formData, handleChange }) {
  return (
    <Box
      sx={{
        maxWidth: 360,
        width: '100%',
        mx: 'auto',        // center horizontally
        py: 2,             // some vertical padding
      }}
    >
      <Typography 
        variant="h6" 
        component="p" 
        gutterBottom 
        align="center"     // center the title
      >
        Step 1: Personal Information
      </Typography>

      <TextField
        label="Name"
        name="name"
        variant="outlined"
        value={formData.name}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Company"
        name="company"
        variant="outlined"
        value={formData.company}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Job Title"
        name="jobTitle"
        variant="outlined"
        value={formData.jobTitle}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
    </Box>
  );
}

export default Step1PersonalInfo;
